import types from './types';
import { arrayToLookup } from '../../utils/helpers';

const initialState = {
  currentResource: null,
  currentDispatchID: '',
  fields: null,
  filters: {},
  sql: null,
  resource: null,
  request: null,
  resourceListColumns: [
    'OperationalName',
    'CreatedBySystem',
    'ModifiedOnDateTime',
    'OperationalStatus'
  ]
};

const resourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RESOURCE:
      return {
        ...state,
        currentResource: action.payload.resource
      };

      case types.SET_DISPATCH:
      return {
        ...state,
        currentDispatchID: action.payload.currentDispatchID
      };

    case types.SET_RESOURCE_FIELDS:
      return {
        ...state,
        fields: action.payload.fields
      };

    case types.SET_REQUEST_FIELDS:
      return {
        ...state,
        request: {fields: action.payload.request}
      };

    case types.CLEAR_RESOURCE:
      return {
        ...state,
        currentResource: initialState.currentResource
      };

    case types.SET_INITIAL_RESOURCE_FILTER:
      return { ...state, filters: action.payload.filterState };

    case types.UPDATE_RESOURCE_FILTER_VALUES:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.name]: {
            ...state.filters[action.payload.name],
            values: action.payload.values
          }
        }
      };

    case types.UPDATE_RESOURCE_SQL_FILTER:
      return { ...state, sql: action.payload.sql };

    case types.CLEAR_RESOURCE_FILTERS:
      const filtersArr = Object.keys(state.filters).map(key => {
        const filter = state.filters[key];

        return { ...filter, values: [] };
      });

      const filters = arrayToLookup(filtersArr, 'name');

      return { ...state, filters };

    case types.SET_INITIAL_RESOURCE_LIST_COLUMNS:
      const initialColumns = action.payload.columns
        ? action.payload.columns
        : initialState.resourceListColumns;

      return { ...state, resourceListColumns: initialColumns };

    case types.ADD_RESOURCE_LIST_COLUMN:
      // add a resource list column
      const addedName = action.payload.columnName;

      // and optionally provide an index position (defaults to last position if absent)
      const indexPosition =
        action.payload.indexPosition || action.payload.indexPosition === 0
          ? action.payload.indexPosition
          : state.resourceListColumns.length;

      // filter along the way to keep out any duplicate column names
      const uniqueResourceListColumns = state.resourceListColumns.filter(
        columnName => columnName !== addedName
      );

      // add the new column at a specific place in the array
      uniqueResourceListColumns.splice(indexPosition, 0, addedName);

      return {
        ...state,
        resourceListColumns: uniqueResourceListColumns
      };

    case types.REMOVE_RESOURCE_LIST_COLUMN:
      // remove a resource list column
      const removedName = action.payload.columnName;
      const fewerResourceListColumns = state.resourceListColumns.filter(
        columnName => columnName !== removedName
      );

      return {
        ...state,
        resourceListColumns: fewerResourceListColumns
      };

    default:
      return state;
  }
};

export default resourceReducer;



// WEBPACK FOOTER //
// ./src/redux/resource/reducers.js